export const env = process.env.NODE_ENV;
export const cdnHost = process.env.CDN_HOST;
export const gaId = 'UA-12122721-3';
export const fbId = '530342757332957';
export const validatePhoneUrl = process.env.VALIDATE_PHONE_NUMBER_ENDPOINT;
export const pushNotificationURL = process.env.SEND_PUSH_TO_TAG_PROD_ENDPOINT;
export const SET_ITEM_COUNT_DEBOUNCE_TIME = 1000;
export const host = process.env.HOST;
export const qsApiHost = process.env.QS_API_HOST;
export const paymentHost = process.env.PAYMENT_HOST;
export const analyticsEnabled = process.env.ANALYTICS;
export const BLUR_TIMEOUT = 60000;
export const CHAT_POPOVER_BREAKPOINT = 775;
export const NAVBAR_HEIGHT = 55;
export const NAVBAR_LOGO_HEIGHT = 30;
export const NAVBAR_LARGE_LOGO_HEIGHT = 45;
export const NAVBAR_BANNER_HEIGHT = 45;
export const NAVBAR_WITH_BANNER_HEIGHT = 100;
export const POWERED_BY_LOGO_HEIGHT = 104;
export const POWERED_BY_LOGO_WIDTH = 324;
export const POWERED_BY_LOGO_MAX_HEIGHT = 40;
export const ORDER_BAR_BREAKPOINT = 775;
export const SHIFT_VIDEO_TO_POSITION_N = 1;
export const SEND_INQUIRY_ANIMATION_TIME = 750;
export const GALLERY_PAGE_THUMBNAIL_HEIGHT = 60;
export const GALLERY_PAGE_THUMBNAIL_WIDTH = 60;
export const GALLERY_PAGE_THUMBNAIL_DESKTOP_HEIGHT = 90;
export const driftCompanyId = process.env.DRIFT_COMPANY_ID;
export const SINGLE_AMALGAM_PAGE_SIZE = 30;
export const USER_TAG_SUFFIX = '|||';
export const bugsnagApiKey = process.env.BUGSNAG_API_KEY;
export const catalogueSWHost = '/';
export const firebaseURL = process.env.FIREBASE_URL;
export const firebaseApiKey = process.env.FIREBASE_API_KEY;
export const firebaseAuthDomain = process.env.FIREBASE_AUTH_DOMAIN;
export const firebaseProjectId = process.env.FIREBASE_PROJECT_ID;
export const s3ImagesEndpoint = process.env.S3_IMAGES_ENDPOINT;
export const s3ImagesCdnEndpoint = process.env.S3_IMAGES_CDN_ENDPOINT;
export const s3BannerImagesEndpoint = process.env.S3_BANNER_IMAGES_ENDPOINT;
export const s3BannerImagesCdnEndpoint = process.env.S3_BANNER_IMAGES_CDN_ENDPOINT;
export const s3VideosEndpoint = process.env.S3_VIDEOS_ENDPOINT;
export const s3VideosCdnEndpoint = process.env.S3_VIDEOS_CDN_ENDPOINT;
export const analyticsIngestorEndpoint = process.env.ANALYTICS_INGESTOR_ENDPOINT;
